import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DEFAULT_SEO_CONFIG, SEO_CONFIG_KEY, parseSeoConfig, type SeoConfig } from "@/seo/seoConfig";

/**
 * Reads the admin-configured SEO & AI-search config from `admin_settings`
 * (key `seo_config`) and merges it over the code defaults. Powers the runtime
 * <SeoManager> and the Theme Options editor. Falls back to defaults when the
 * row is absent or unparseable.
 */
export function useSeoConfig() {
  return useQuery<SeoConfig>({
    queryKey: ["seo-config"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("admin_settings")
        .select("value")
        .eq("key", SEO_CONFIG_KEY)
        .maybeSingle();
      if (error) throw error;
      return parseSeoConfig(data?.value);
    },
    staleTime: 5 * 60 * 1000,
    initialData: DEFAULT_SEO_CONFIG,
  });
}
